import React from 'react';
import { useParams } from 'react-router-dom';

import SystemEmailPage from './SystemEmailPage';

const SystemEmailModalRoute: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const mode = id ? 'edit' : 'create';

  return (
    <SystemEmailPage
      initialModal={{
        mode,
        emailTemplateId: id,
      }}
      modalReturnTo="/email"
    />
  );
};

export default SystemEmailModalRoute;
